import React from 'react'
import { backgroundColors } from '../../Color/Color'
import { PageContainer } from '@toolpad/core'

interface PageContentProps {
  components: React.ReactNode
}

const PageContent: React.FC<PageContentProps> = ({ components }) => {
  return (
    <PageContainer
      title=''
      breadcrumbs={[]}
      maxWidth={false}
      sx={{ backgroundColor: backgroundColors.greyMystic }}
    >
      {components}
    </PageContainer>
  )
}

export default PageContent
